import React from "react";
import { Panel, Text } from "../../design-system";
import { Feed } from "../../pages/News/News.data";

const FeedItem: React.FC<Feed> = (props) => {
  return (
    <Panel className="mb-4 flex w-full justify-center border-l-2 border-l-feed-border p-[clamp(18px,3vw,32px)]">
      {/* <Avatar src={avatar} alt="Avatar" /> */}

      <div className="flex w-full min-w-0 flex-col leading-feed [overflow-wrap:anywhere] [&_img]:block [&_img]:h-auto [&_img]:max-h-[520px] max-[640px]:[&_img]:max-h-[420px] [&_a]:text-link">
        <Text variant="date">{props.date}</Text>
        <span className="mb-3 mt-1.5 text-[clamp(1.1rem,2vw,1.4rem)] font-bold uppercase leading-tight">{props.title}</span>

        <p className="m-0 whitespace-pre-line">{props.text}</p>

        {props.youtubeLink && (
          <div className="mt-4 aspect-video w-full [&_iframe]:h-full [&_iframe]:w-full [&_iframe]:border-0">
            <iframe
              width="100%"
              height="100%"
              src={props.youtubeLink}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}

        <div className="flex justify-start pt-3">{props.bodyContent}</div>
      </div>
    </Panel>
  );
};

export default FeedItem;
